function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M477.008,250.104h-68.471c-19.294,0-34.992,15.701-34.992,35v93.372H352.5V229.501h59.25c3.32,0,6.424-1.648,8.284-4.398 s2.233-6.245,0.997-9.326l-20-49.845c-1.521-3.791-5.196-6.276-9.281-6.276h-98v-44.655h73.575c5.523,0,10-4.477,10-10v-75 c0-5.523-4.477-10-10-10h-35.981c-5.452-7.563-14.33-12.5-24.344-12.5s-18.892,4.937-24.344,12.5h-53.312 c-5.452-7.563-14.33-12.5-24.344-12.5s-18.892,4.937-24.344,12.5h-35.998c-5.523,0-10,4.477-10,10v75c0,5.523,4.477,10,10,10h73.592 v44.655h-98c-4.085,0-7.759,2.485-9.281,6.276l-20,49.845c-1.236,3.081-0.863,6.575,0.997,9.326c1.86,2.75,4.963,4.398,8.284,4.398 H160v148.975h-21.545v-93.372c0-19.299-15.697-35-34.992-35H34.992c-19.294,0-34.992,15.701-34.992,35v184.397 c0,19.299,15.697,35,34.992,35h68.471c19.294,0,34.992-15.701,34.992-35v-29.394h235.091v29.394c0,19.299,15.697,35,34.992,35 h68.471c19.294,0,34.992-15.701,34.992-35V285.104C512,265.804,496.303,250.104,477.008,250.104z M307,27.501 c5.514,0,10,4.486,10,10s-4.486,10-10,10s-10-4.486-10-10S301.486,27.501,307,27.501z M205,27.501c5.514,0,10,4.486,10,10 s-4.486,10-10,10s-10-4.486-10-10S199.486,27.501,205,27.501z M154.658,40.001h20.454c1.276,15.376,14.188,27.5,29.888,27.5 s28.612-12.124,29.888-27.5h42.224c1.276,15.376,14.188,27.5,29.888,27.5s28.612-12.124,29.888-27.5h20.437v55H154.658V40.001z  M446.748,425.645c-2.536-1.099-5.413-1.099-7.949,0l-45.253,19.602v-23.204l49.228-21.323L492,422.042v23.204L446.748,425.645z  M446.748,380.645c-2.536-1.099-5.413-1.099-7.949,0l-45.253,19.602v-22.204l49.228-21.323L492,378.042v22.204L446.748,380.645z  M492,334.042v22.204l-45.252-19.602c-2.536-1.099-5.413-1.099-7.949,0l-45.253,19.602v-22.204l49.228-21.323L492,334.042z  M393.545,285.104c0-8.271,6.725-15,14.992-15h68.471c8.267,0,14.992,6.729,14.992,15v27.143l-45.252-19.602 c-2.536-1.099-5.413-1.099-7.949,0l-45.253,19.602v-27.143H393.545z M238.25,122.501h35.5v37.155h-35.5V122.501z M115.038,209.501 l11.975-29.845h257.975l11.975,29.845H342.5c-5.523,0-10,4.477-10,10v30.6h-35.83c-5.52,0-10,4.49-10,10c0,5.52,4.48,10,10,10h35.83 v108.375H180V270.101h36.67c5.51,0,10-4.48,10-10c0-5.51-4.49-10-10-10H180v-30.6c0-5.523-4.477-10-10-10H115.038z M72.107,425.251 c-1.873-0.563-3.868-0.565-5.741-0.005c-0.376,0.112-46.366,20-46.366,20v-23.204l49.227-21.323l49.228,21.323v23.204 C118.455,445.246,72.477,425.362,72.107,425.251z M20,400.246v-22.204l49.227-21.323l49.228,21.323v22.204 c0,0-45.977-19.884-46.347-19.996c-1.873-0.563-3.868-0.565-5.741-0.005C65.99,380.358,20,400.246,20,400.246z M118.455,334.042 v22.204c0,0-45.977-19.884-46.347-19.996c-1.873-0.563-3.868-0.565-5.741-0.005c-0.376,0.112-46.366,20-46.366,20V334.04 l49.227-21.323L118.455,334.042z M34.992,270.104h68.471c8.267,0,14.992,6.729,14.992,15v27.143c0,0-45.977-19.884-46.347-19.996 c-1.873-0.563-3.868-0.565-5.741-0.005c-0.376,0.112-46.366,20-46.366,20v-27.143C20,276.833,26.725,270.104,34.992,270.104z  M118.455,469.501c0,8.271-6.725,15-14.992,15H34.992c-8.267,0-14.992-6.729-14.992-15v-2.459l49.227-21.323l49.228,21.323V469.501z  M138.455,398.476H160v21.631h-21.545V398.476z M180,398.476h152.5v21.631H180V398.476z M352.5,420.107v-21.631h21.045v21.631H352.5 z M492,469.501c0,8.271-6.725,15-14.992,15h-68.471c-8.267,0-14.992-6.729-14.992-15v-2.459l49.228-21.323L492,467.042V469.501z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.67,270.101c5.51,0,10-4.48,10-10c0-5.51-4.49-10-10-10c-5.52,0-10,4.49-10,10 C246.67,265.621,251.15,270.101,256.67,270.101z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var SvgRobot = function SvgRobot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("polygon", {
    style: {
      fill: "#75706B"
    },
    points: "128.454,371.476 128.454,327.476 69.227,301.821 10,327.476 10,371.476 69.227,345.821 "
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#CBC2BA"
    },
    d: "M128.454,327.476v-42.372c0-13.75-11.246-25-24.992-25h-68.47c-13.745,0-24.992,11.25-24.992,25 v42.372l59.227-25.655L128.454,327.476z"
  }), React.createElement("polygon", {
    style: {
      fill: "#CBC2BA"
    },
    points: "69.227,345.821 10,371.476 10,415.476 69.227,389.821 128.454,415.476 128.454,371.476  "
  }), React.createElement("path", {
    style: {
      fill: "#CBC2BA"
    },
    d: "M10,460.476v9.025c0,13.75,11.246,25,24.992,25h68.471c13.745,0,24.992-11.25,24.992-25v-9.025 l-59.228-25.655L10,460.476z"
  })), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#75706B"
    },
    points: "10,415.476 10,460.476 69.227,434.821 128.454,460.476 128.454,415.476 69.227,389.821  "
  }), React.createElement("polygon", {
    style: {
      fill: "#75706B"
    },
    points: "502,371.476 502,327.476 442.773,301.821 383.546,327.476 383.546,371.476 442.773,345.821  "
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#CBC2BA"
    },
    d: "M502,327.476v-42.372c0-13.75-11.246-25-24.992-25h-68.471c-13.745,0-24.992,11.25-24.992,25v42.372 l59.227-25.655L502,327.476z"
  }), React.createElement("polygon", {
    style: {
      fill: "#CBC2BA"
    },
    points: "442.773,345.821 383.546,371.476 383.546,415.476 442.773,389.821 502,415.476 502,371.476  "
  }), React.createElement("path", {
    style: {
      fill: "#CBC2BA"
    },
    d: "M383.546,460.476v9.025c0,13.75,11.246,25,24.992,25h68.471c13.745,0,24.992-11.25,24.992-25v-9.025 l-59.227-25.655L383.546,460.476z"
  })), React.createElement("g", null, React.createElement("polygon", {
    style: {
      fill: "#75706B"
    },
    points: "383.546,415.476 383.546,460.476 442.773,434.821 502,460.476 502,415.476 442.773,389.821  "
  }), React.createElement("rect", {
    x: 228.25,
    y: 112.501,
    style: {
      fill: "#75706B"
    },
    width: 55.5,
    height: 57.16
  }), React.createElement("rect", {
    x: 128.45,
    y: 388.481,
    style: {
      fill: "#75706B"
    },
    width: 41.546,
    height: 41.631
  }), React.createElement("rect", {
    x: 342.5,
    y: 388.481,
    style: {
      fill: "#75706B"
    },
    width: 41.05,
    height: 41.631
  })), React.createElement("rect", {
    x: 170,
    y: 388.481,
    style: {
      fill: "#CBC2BA"
    },
    width: 172.5,
    height: 41.631
  }), React.createElement("polygon", {
    style: {
      fill: "#EEEEEE"
    },
    points: "411.75,219.501 391.75,169.656 120.25,169.656 100.25,219.501 170,219.501 170,388.476  342.5,388.476 342.5,219.501 "
  }), React.createElement("path", {
    style: {
      fill: "#CBC2BA"
    },
    d: "M327,37.501c0,11.046-8.954,20-20,20s-20-8.954-20-20h-62c0,11.046-8.954,20-20,20s-20-8.954-20-20 h-39v75h222.667v-75H327z"
  }), React.createElement("g", null, React.createElement("circle", {
    style: {
      fill: "#F6931E"
    },
    cx: 205,
    cy: 37.501,
    r: 20
  }), React.createElement("circle", {
    style: {
      fill: "#F6931E"
    },
    cx: 307,
    cy: 37.501,
    r: 20
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRobot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/robot.88a3fcb6.svg";
export { ForwardRef as ReactComponent };